import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class SecurityPermissions extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/security/permission'
    super(store, path)
  }
  list(showProgress) {
    return this._request({
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
  getTree(filter, showProgress) {
    return this._request({
      action: 'tree',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
